<template>
    <div class="col-md-6 col-sm-6 mb-4">
        <BlogCard :blog="blog"/>
    </div>
</template>

<script>
    import BlogCard from '../../BlogCard.vue';

    export default {
        components: { BlogCard },

        props: ['blog'],
    };
</script>
